import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import { util, cookieUtil } from '@/utils/utils.js'
import corp from './corp/index'

Vue.use(Router)

const router = new Router({
    routes: [
      ...corp,
      {
            path: '/page',
            component: index,
            children: [{
                    path: '',
                    meta: {
                        title: '工程概况'
                    },
                    component: resolve => require(['@/components/projProfile/index.vue'], resolve)
                },
                {
                    path: 'router333',
                    name: 'router333',
                    meta: {
                        title: '首页'
                    },
                    component: resolve => require(['@/components/projProfile/router333.vue'], resolve)
                },
                {
                    path: 'monitoring',
                    name: 'monitoring',
                    meta: {
                        title: '实时监控'
                    },
                    component: resolve => require(['@/components/monitoring/monitoringIndex.vue'], resolve)
                },
                {
                  path: 'IntelligentWashing',
                  name: 'IntelligentWashing',
                  meta: {
                      title: '智能冲洗'
                  },
                  component: resolve => require(['@/components/IntelligentWashing/index.vue'], resolve)
                },
                {
                    path: 'progress',
                    name: 'progress',
                    meta: {
                        title: '工程进度'
                    },
                    component: resolve => require(['@/components/progress/progressIndex.vue'], resolve)
                },
                {
                    path: 'equipmentIndex',
                    name: 'equipmentIndex',
                    meta: {
                        title: '设备管理'
                    },
                    component: resolve => require(['@/components/equipment/equipmentIndex.vue'], resolve)
                },
                {
                    path: 'environmental',
                    name: 'environmental',
                    meta: {
                        title: '环境监控'
                    },
                    component: resolve => require(['@/components/environmental/environmentalIndex.vue'], resolve)
                },
                {
                    path: 'crane',
                    name: 'crane',
                    meta: {
                        title: '塔机监测'
                    },
                    component: resolve => require(['@/components/crane/craneIndex.vue'], resolve)
                },
                {
                  path: 'lifter',
                  name: 'lifter',
                  meta: {
                      title: '升降机监测'
                  },
                  component: resolve => require(['@/components/lifter/lifterIndex.vue'], resolve)
                },
                {
                    path: 'SystemDocumentation',
                    name: 'SystemDocumentation',
                    meta: {
                        title: '工程文档'
                    },
                    component: resolve => require(['@/components/projectDocuments/SystemDocumentation.vue'], resolve)
                },
                {
                    path: 'checkManage',
                    component: resolve => require(['@/components/checkManage/checkManageIndex.vue'], resolve),
                    children: [
                        {
                            path: '',
                            meta: {
                                title: '首页'
                            },
                            component: resolve => require(['@/components/checkManage/checkIndex.vue'], resolve)
                        },
                        {
                            path: 'checkProblem',
                            path: 'checkProblem',
                            meta: {
                                title: '检查问题'
                            },
                            component: resolve => require(['@/components/checkManage/checkProblem.vue'], resolve)
                        },
                        {
                            path: 'checkSet',
                            name: 'checkSet',
                            meta: {
                                title: '检查项设置'
                            },
                            component: resolve => require(['@/components/checkManage/checkSet.vue'], resolve)
                        },

                    ]
                },
                {
                    path: 'realNameSystem',
                    component: resolve => require(['@/components/realNameSystem/realNameSystemIndex.vue'], resolve),
                    children: [
                      {
                        path: '',
                        meta: {
                          title: '实名制-首页'
                        },
                        component: resolve => require(['@/components/realNameSystem/index.vue'], resolve)
                      },
                      {
                        path: 'ShiftManagement',
                        name: 'ShiftManagement',
                        meta: {
                          title: '实名制-班次管理'
                        },
                        component: resolve => require(['@/components/realNameSystem/ShiftManagement.vue'], resolve),
                      },
                      {
                        path: 'signinRecord',
                        meta: {
                          title: '实名制-考勤'
                        },
                        component: resolve => require(['@/components/realNameSystem/signinRecord.vue'], resolve)
                      },
                      {
                        path: 'memberManage',
                        name: 'memberManage',
                        meta: {
                          title: '实名制-人员管理'
                        },
                        component: resolve => require(['@/components/realNameSystem/memberManage.vue'], resolve),
                      },
                      {
                        path: 'gateBrake',
                        name: 'gateBrake',
                        meta: {
                          title: '实名制-闸机设置'
                        },
                        component: resolve => require(['@/components/realNameSystem/gateBrake.vue'], resolve),
                      },
                      {
                        path: 'LaborContract',
                        name: 'LaborContract',
                        meta: {
                          title: '实名制-劳动合同'
                        },
                        component: resolve => require(['@/components/realNameSystem/LaborContract.vue'], resolve),
                      },
                      {
                        path: 'WorkforceManagement',
                        name: 'WorkforceManagement',
                        meta: {
                          title: '实名制-排班管理'
                        },
                        component: resolve => require(['@/components/realNameSystem/WorkforceManagement.vue'], resolve),
                      },
                      {
                        path: 'signinRecord',
                        name: 'signinRecord',
                        meta: {
                          title: '实名制-考勤记录'
                        },
                        component: resolve => require(['@/components/realNameSystem/signinRecord.vue'], resolve),
                      },
                      {
                        path: 'CreditRecord',
                        name: 'CreditRecord',
                        meta: {
                          title: '实名制-征信记录'
                        },
                        component: resolve => require(['@/components/realNameSystem/CreditRecord.vue'], resolve),
                      },
                      {
                        path: 'punishmentReward',
                        name: 'punishmentReward',
                        meta: {
                          title: '实名制-惩罚奖励'
                        },
                        component: resolve => require(['@/components/realNameSystem/PunishmentReward.vue'], resolve),
                      },
                      {
                        path: 'AdvanceAndRetreat',
                        name: 'AdvanceAndRetreat',
                        meta: {
                          title: '实名制-人员进退场'
                        },
                        component: resolve => require(['@/components/realNameSystem/AdvanceAndRetreat.vue'], resolve),
                      },
                      {
                        path: 'WageManagement',
                        name: 'WageManagement',
                        meta: {
                          title: '实名制-工资管理'
                        },
                        component: resolve => require(['@/components/realNameSystem/WageManagement.vue'], resolve),
                      },
                      {
                        path: 'TrainingManagement',
                        name: 'TrainingManagement',
                        meta: {
                          title: '实名制-培训管理'
                        },
                        component: resolve => require(['@/components/realNameSystem/TrainingManagement.vue'], resolve),
                      },
                      {
                        path: 'showDetails',
                        name: 'showDetails',
                        meta: {
                          title: '实名制-大屏展示'
                        },
                        component: resolve => require(['@/components/realNameSystem/showDetails.vue'], resolve),
                      },
                    ]
                },
                {
                  path: 'ProcessManagement',
                  component: resolve => require(['@/components/ProcessManagement/index.vue'], resolve),
                  children: [
                    {
                      path: '',
                      meta: {
                        title: '工序-首页'
                      },
                      component: resolve => require(['@/components/ProcessManagement/ProcessManagementIndex.vue'], resolve)
                    },
                    {
                      path: 'workingProcedure',
                      meta: {
                        title: '工序-工序管理'
                      },
                      component: resolve => require(['@/components/ProcessManagement/workingProcedure.vue'], resolve)
                    },
                    {
                      path: 'InspectionLot',
                      meta: {
                        title: '工序-工序检验批'
                      },
                      component: resolve => require(['@/components/ProcessManagement/InspectionLot.vue'], resolve)
                    },
                    {
                      path: 'ProcessTask',
                      meta: {
                        title: '工序-工序任务'
                      },
                      component: resolve => require(['@/components/ProcessManagement/ProcessTask.vue'], resolve)
                    },
                    {
                      path: 'Rectification',
                      meta: {
                        title: '工序-问题整改'
                      },
                      component: resolve => require(['@/components/ProcessManagement/Rectification.vue'], resolve)
                    },
                    {
                      path: 'ProcessStatistics',
                      meta: {
                        title: '工序-统计'
                      },
                      component: resolve => require(['@/components/ProcessManagement/ProcessStatistics.vue'], resolve)
                    },
                  ]
                },
                {
                    path: 'measured',
                    component: resolve => require(['@/components/measured/PageIndex.vue'], resolve),
                    children: [
                        {
                            path: '',
                            meta: {
                                title: '首页'
                            },
                            component: resolve => require(['@/components/measured/MeasuredIndex.vue'], resolve)
                        },
                        {
                            path: 'areaMeasured',
                            path: 'areaMeasured',
                            meta: {
                                title: '区域测点'
                            },
                            component: resolve => require(['@/components/measured/AreaMeasured.vue'], resolve)
                        },
                        {
                            path: 'jurisdiction',
                            path: 'jurisdiction',
                            meta: {
                                title: '权限配置'
                            },
                            component: resolve => require(['@/components/measured/Jurisdiction.vue'], resolve)
                        },
                        {
                            path: 'checkProblem',
                            path: 'checkProblem',
                            meta: {
                                title: '问题整改'
                            },
                            component: resolve => require(['@/components/measured/MeasuredProblem.vue'], resolve)
                        },

                    ]
                },
                {
                    path: '*',
                    redirect: '/page',
                },
            ],
        },
        {
            path: '/common',
            component: resolve => require(['@/common/index.vue'], resolve),
            children: [{
                path: 'leaflet',
                meta: {
                    title: '图片预览'
                },
                component: resolve => require(['@/common/leaflet.vue'], resolve)
            }]
        },
        {
            path: '/login',
            meta: {
                title: '智慧工地管理平台'
            },
            component: resolve => require(['@/components/login.vue'], resolve),
        },
        {
            path: '/register',
            meta: {
                title: '注册'
            },
            component: resolve => require(['@/components/Register.vue'], resolve),
        },
        {
            path: '/proj',
            meta: {
                title: '项目'
            },
            component: resolve => require(['@/components/proj.vue'], resolve),
        },
        {
          path: '/showDetails',
          name: 'showDetails',
          meta: {
            title: '实名制-大屏展示'
          },
          component: resolve => require(['@/components/realNameSystem/showDetails.vue'], resolve),
        },
        {
            path: '*',
            redirect: '/login',
        },
    ]
})
router.beforeEach((to, from, next) => {
    // to and from are both route objects

    document.title = to.meta.title;
    // util.mask('正在跳转..')
    if (to.path == '/login'||to.path == '/register' || to.path=='/corp/register') {
        next()
        util.unmask()
    } else {
        if (cookieUtil.validToken()) { // 如果有就直接到首页
            console.log(JSON.parse(cookieUtil.get('projectNode'))&&JSON.parse(cookieUtil.get('projectNode')).id)
            if((JSON.parse(cookieUtil.get('projectNode'))&&JSON.parse(cookieUtil.get('projectNode')).id)||to.path == '/proj'){
                next()
            }else{
                next('/proj')
            }
            util.unmask()
        } else {
            util.error('没有获取到用户信息');
            next('/login');
            util.unmask()
        }
    }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js